<template>
  <gc-dialog
    v-model="wallboxModalOpen"
    width="650"
    scrollable
    class="gc-dialog-vehicle"
  >
    <gc-card v-if="selectedWallbox && selectedWallbox.id">
      <div
        class="d-flex flex-column flex-sm-row align-center justify-space-between px-8 py-5 grey lighten-5"
      >
        <h2 class="text-title-1 text--primary font-weight-bold mb-3 mb-sm-0">
          {{ selectedWallbox.translated.name }}
        </h2>
        <div class="d-flex">
          <gc-button color="primary" text @click="closeWallboxModal()">
            <font-awesome-icon :icon="faTimes" class="mr-2" />
            {{ $t('wallboxes.modal.button.close') }}
          </gc-button>
        </div>
      </div>

      <gc-divider></gc-divider>

      <gc-card-text class="pa-0">
        <gc-image
          :height="250"
          contain
          :src="`${productUrl(selectedWallbox)}`"
        />
        <div class="px-8 pb-8">
          <gc-row>
            <gc-col cols="12" sm="6">
              <h4 class="text-h6 text--primary">
                {{ $t('wallboxes.modal.details.general.label') }}
              </h4>
              <gc-divider class="mt-1 mb-3" />

              <!-- Manufacturer -->
              <wallbox-details-item
                :label="
                  $t('wallboxData.manufacturerIdentifier.label').toString()
                "
                v-if="wallboxData.manufacturerIdentifier"
              >
                {{ wallboxData.manufacturerIdentifier }}
              </wallbox-details-item>

              <!-- Charging Power -->
              <wallbox-details-item
                :label="$t('wallboxData.chargingPowersWatt.label').toString()"
                v-if="chargingPowersWatt()"
              >
                {{ chargingPowersWatt() }}
              </wallbox-details-item>

              <!-- Charging Power Configurable -->
              <wallbox-details-item
                v-if="wallboxData.chargingPowerConfigurable"
                :label="
                  $t(
                    'wallboxes.modal.details.general.chargingPowerConfigurable',
                  ).toString()
                "
              >
              </wallbox-details-item>

              <!-- Ampere Powers -->
              <wallbox-details-item
                :label="
                  $t('wallboxData.electricCurrentsAmpere.label').toString()
                "
                v-if="amperePowers()"
              >
                {{ amperePowers() }}
              </wallbox-details-item>
              <!-- Ampere Powers Configurable -->
              <wallbox-details-item
                v-if="wallboxData.electricCurrentConfigurable"
                :label="
                  $t(
                    'wallboxes.modal.details.general.electricCurrentConfigurable',
                  ).toString()
                "
              >
              </wallbox-details-item>

              <!-- Voltages -->
              <wallbox-details-item
                :label="$t('wallboxData.voltagesVolt.label').toString()"
                v-if="voltages()"
              >
                {{ voltages() }}
              </wallbox-details-item>

              <!-- Phases -->
              <wallbox-details-item
                :label="$t('wallboxData.noOfPhases.label').toString()"
                v-if="phases()"
              >
                {{ phases() }}
              </wallbox-details-item>

              <!-- Electric Protection Devices -->
              <wallbox-details-item
                :label="
                  $t('wallboxData.electricProtectionDevices.label').toString()
                "
                v-if="electricProtectionDevices()"
              >
                {{ electricProtectionDevices() }}
              </wallbox-details-item>

              <!-- Protocols -->
              <wallbox-details-item
                :label="$t('wallboxData.protocols.label').toString()"
                v-if="protocols()"
              >
                {{ protocols() }}
              </wallbox-details-item>

              <!-- Network Connectors -->
              <wallbox-details-item
                :label="$t('wallboxData.networkConnectors.label').toString()"
                v-if="networkConnectors()"
              >
                {{ networkConnectors() }}
              </wallbox-details-item>

              <!-- Protection Classes -->
              <wallbox-details-item
                :label="$t('wallboxData.protectionClasses.label').toString()"
                v-if="protectionClasses()"
              >
                {{ protectionClasses() }}
              </wallbox-details-item>

              <!-- Extras -->
              <h4 class="text-h6 text--primary mt-5">
                {{ $t('wallboxes.modal.extras.label') }}
              </h4>

              <gc-divider class="mt-1 mb-3" />

              <!-- Load Management -->
              <wallbox-details-item
                v-if="wallboxData.loadManagement"
                :label="$t('wallboxData.loadManagement.label').toString()"
              >
              </wallbox-details-item>

              <!-- Billable -->
              <wallbox-details-item
                v-if="wallboxData.billable"
                :label="$t('wallboxData.billable.label').toString()"
              >
              </wallbox-details-item>

              <!-- Billing Solution -->
              <wallbox-details-item
                v-if="wallboxData.billingSolution"
                :label="$t('wallboxData.billingSolution.label').toString()"
              >
              </wallbox-details-item>

              <!-- Smartphone Controllable -->
              <wallbox-details-item
                v-if="wallboxData.smartphoneControllable"
                :label="
                  $t('wallboxData.smartphoneControllable.label').toString()
                "
              >
              </wallbox-details-item>

              <!-- PV Combinable -->
              <wallbox-details-item
                v-if="wallboxData.pvCombinable"
                :label="$t('wallboxData.pvCombinable.label').toString()"
              >
              </wallbox-details-item>

              <!-- Outdoor Ready -->
              <wallbox-details-item
                v-if="wallboxData.outdoorReady"
                :label="$t('wallboxData.outdoorReady.label').toString()"
              >
              </wallbox-details-item>

              <!-- Climate Neutral -->
              <wallbox-details-item
                v-if="wallboxData.climateNeutral"
                :label="$t('wallboxData.climateNeutral.label').toString()"
              >
              </wallbox-details-item>
            </gc-col>
            <gc-col cols="12" sm="6">
              <!-- Charging Points -->
              <h4 class="text-h6 text--primary">
                {{ $t('wallboxes.modal.chargingPoints.label') }}
              </h4>

              <gc-divider class="mt-1 mb-3" />

              <!-- Number of Charging Points -->
              <wallbox-details-item
                :label="$t('wallboxData.noOfChargingPoints.label').toString()"
                v-if="noOfChargingPoints()"
              >
                {{ noOfChargingPoints() }}
              </wallbox-details-item>

              <!-- Charging Connector Types -->
              <wallbox-details-item
                :label="
                  $t('wallboxData.chargingConnectorTypes.label').toString()
                "
                v-if="chargingConnectorTypes()"
              >
                {{ chargingConnectorTypes() }}
              </wallbox-details-item>

              <!-- Installation Options -->
              <wallbox-details-item
                :label="$t('wallboxData.installationOptions.label').toString()"
                v-if="installationOptions()"
              >
                {{ installationOptions() }}
              </wallbox-details-item>

              <!-- Cable Length -->
              <wallbox-details-item
                :label="$t('wallboxData.cableLengthMeter.label').toString()"
                v-if="cableLengthMeter()"
              >
                {{ cableLengthMeter() }}
              </wallbox-details-item>

              <!-- Display Types -->
              <wallbox-details-item
                :label="$t('wallboxData.displayTypes.label').toString()"
                v-if="displayTypes()"
              >
                {{ displayTypes() }}
              </wallbox-details-item>

              <!-- Access Protection Options -->
              <wallbox-details-item
                :label="
                  $t('wallboxData.accessProtectionOptions.label').toString()
                "
                v-if="accessProtectionOptions()"
              >
                {{ accessProtectionOptions() }}
              </wallbox-details-item>

              <!-- Access Protection Options -->
              <wallbox-details-item
                :label="$t('wallboxData.energyMeters.label').toString()"
                v-if="energyMeters()"
              >
                {{ energyMeters() }}
              </wallbox-details-item>

              <!-- Dimensions -->
              <h4 class="text-h6 text--primary mt-5">
                {{ $t('wallboxes.modal.dimensions.label') }}
              </h4>

              <gc-divider class="mt-1 mb-3" />

              <!-- Width -->
              <wallbox-details-item
                :label="$t('wallboxes.modal.dimensions.width').toString()"
                v-if="selectedWallbox.width"
              >
                {{ selectedWallbox.width.toString() + ' mm' }}
              </wallbox-details-item>

              <!-- Height -->
              <wallbox-details-item
                :label="$t('wallboxes.modal.dimensions.height').toString()"
                v-if="selectedWallbox.height"
              >
                {{ selectedWallbox.height.toString() + ' mm' }}
              </wallbox-details-item>

              <!-- Length -->
              <wallbox-details-item
                :label="$t('wallboxes.modal.dimensions.length').toString()"
                v-if="selectedWallbox.length"
              >
                {{ selectedWallbox.length.toString() + ' mm' }}
              </wallbox-details-item>

              <!-- Weight -->
              <wallbox-details-item
                :label="$t('wallboxes.modal.dimensions.weight').toString()"
                v-if="selectedWallbox.weight"
              >
                {{ selectedWallbox.weight.toString() + ' kg' }}
              </wallbox-details-item>
            </gc-col>
          </gc-row>
        </div>
      </gc-card-text>
    </gc-card>
  </gc-dialog>
</template>

<script lang="ts">
import { faCheck, faPlus, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { defineComponent } from '@vue/composition-api';
import GcButton from '@/components/primitives/GcButton.vue';
import GcCard from '@/components/primitives/GcCard.vue';
import GcCardActions from '@/components/primitives/GcCardActions.vue';
import GcCardText from '@/components/primitives/GcCardText.vue';
import GcCol from '@/components/primitives/GcCol.vue';
import GcDialog from '@/components/primitives/GcDialog.vue';
import GcDivider from '@/components/primitives/GcDivider.vue';
import GcImage from '@/components/primitives/GcImage.vue';
import GcRow from '@/components/primitives/GcRow.vue';
import { GcSwProduct } from '@/lib/greenportal/load-products';
import WallboxDetailsItem from '~/components/wallbox-details-item/WallboxDetailsItem.vue';
import { useWallboxModal } from '~/components/wallbox-modal/wallbox-modal';

export default defineComponent({
  components: {
    WallboxDetailsItem,
    GcButton,
    GcCard,
    GcCardActions,
    GcCardText,
    GcCol,
    GcDialog,
    GcDivider,
    GcImage,
    GcRow,
  },
  setup: () => {
    const baseUrl = process.env.VUE_APP_BASE_URL;
    const productUrl = (wallbox: GcSwProduct) =>
      wallbox.cover?.media?.url
        ? wallbox.cover?.media?.url
        : `${baseUrl}/img/image-placeholder.svg`;

    return {
      baseUrl,
      faPlus,
      faTimes,
      faCheck,
      productUrl,
      ...useWallboxModal(),
    };
  },
});
</script>
